import { z } from 'zod'

/**
 * Canonical product HTTP error body (API-ENVELOPE-CONVENTION).
 * Matches createErrorEnvelope().build() plus optional error.details / gate.
 */
export const ProductProblemSchema = z.object({
  contract_version: z.string().min(1),
  error: z.object({
    code: z.string().min(1),
    message: z.string().min(1),
    reference: z.string().min(1),
    details: z.record(z.unknown()).optional(),
    request_id: z.string().optional(),
  }),
  gate: z
    .object({
      open: z.boolean(),
      reason: z.string().optional(),
    })
    .optional(),
})

export type ProductProblem = z.infer<typeof ProductProblemSchema>

export function assertProductProblem(input: unknown): ProductProblem {
  return ProductProblemSchema.parse(input)
}

export function isProductProblem(input: unknown): input is ProductProblem {
  return ProductProblemSchema.safeParse(input).success
}
